"use strict";
/**
 * API helper functions for Profile (student) endpoints
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.profileApi = void 0;
const apiClient_1 = require("./apiClient");
const validation_1 = require("./validation");
const apiMappers_1 = require("./apiMappers");
exports.profileApi = {
    /**
     * Fetch active student profiles for a tenant
     */
    getActiveProfiles: (tenantId) => {
        (0, validation_1.validateId)(tenantId, 'Tenant ID');
        return apiClient_1.apiClient.get(`/profile/active/${tenantId}`).then(data => data.map(apiMappers_1.mapProfile));
    },
    /**
     * Fetch a single profile by ID
     */
    getProfileById: (id) => {
        (0, validation_1.validateId)(id, 'Profile ID');
        return apiClient_1.apiClient.get(`/profile/${id}`).then(apiMappers_1.mapProfile);
    },
    /**
     * Fetch profiles by organization
     */
    getProfilesByOrganization: (orgId) => {
        (0, validation_1.validateId)(orgId, 'Organization ID');
        return apiClient_1.apiClient.get(`/profile/organization/${orgId}`).then(data => data.map(apiMappers_1.mapProfile));
    },
};
